module.exports = __webpack_public_path__ + "static/media/google.4aa10808.png";